import React from 'react';
import Skeleton from 'react-loading-skeleton';

const FeeSkeleton = (): JSX.Element => (
    <div className="fee-skeleton">
        <Skeleton className="fee-skeleton__item" height={18} width="100%" />
        <Skeleton className="fee-skeleton__last-item" height={18} width="65%" />
    </div>
);

export default FeeSkeleton;
